/**
 * 表格跨页勾选：Ant Design onChange 的 selectedRows 只有当前页。
 * 以 keys 为真相，用缓存还原完整行，避免翻页后金额按当前页少算。
 */

export function rememberRows(cache, rows, getKey = (row) => row.id) {
    (rows || []).forEach((row) => {
        const key = row == null ? null : getKey(row);
        if (key == null) return;
        cache.set(key, row);
    });
    return cache;
}

export function rowsFromSelectedKeys(cache, keys) {
    return (keys || []).map((key) => cache.get(key)).filter(Boolean);
}
